import { render, staticRenderFns } from "./WidgetDemo.vue?vue&type=template&id=6a17d902&scoped=true&"
import script from "./WidgetDemo.vue?vue&type=script&lang=js&"
export * from "./WidgetDemo.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDemo.vue?vue&type=style&index=0&id=6a17d902&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17d902",
  null
  
)

export default component.exports